// Normalizer for main currency response

import { AxiosResponse } from '@mint-lib/api';

import {
  CurrenciesListType,
  MainCurrencyType,
  NormalizedMainCurrencyItem,
} from '../api/getMainCurrencies/getMainCurrencies.types.js';
import { CURRENCIES_META } from '../constants/currencies.js';
import { WithCurrenciesApiResponse } from '../types/types.js';

// needs for MainCurrency table generation on FE side
export const normalizeMainCurrencyResponseItems = (
  resp: MainCurrencyType[],
  allCurrencies: CurrenciesListType,
): NormalizedMainCurrencyItem[] => {
  return resp.map((mainCurrency, i) => ({
    currency: { ...allCurrencies[mainCurrency.code], id: mainCurrency.id },
    addedInDruid: !!mainCurrency?.addedInDruid,
    usedInCampaign: !!mainCurrency?.usedInCampaign,
  }));
};

export const normalizeMainCurrencyAxiosResponse = (
  data: AxiosResponse<any, any>,
): WithCurrenciesApiResponse<NormalizedMainCurrencyItem[]> => {
  return {
    ...data.data,
    data: {
      ...data.data.data,
      items: normalizeMainCurrencyResponseItems(
        data.data.data.items,
        CURRENCIES_META,
      ),
    },
  };
};
